import { create } from 'zustand';

export const useTimezoneStore = create((set) => ({
  timezone: '',
  offset: 0,
  setTimezoneInfo: (timezoneInfo) => set(timezoneInfo),
})); 